import { Injectable } from '@angular/core';
import { FeatureInfoPanelData, LoginOption, ProfileKey } from './visor.types';

@Injectable({ providedIn: 'root' })
export class ViewerStateService {
  showCertificateCallback = window.location.pathname === '/auth/callback';
  showLogin = window.location.pathname === '/perfiles' || this.showCertificateCallback;
  showIrrigatorAuth = false;
  showGuardAuth = false;
  showManagerAuth = false;
  certificateCallbackError = '';
  certificateCallbackLoading = false;

  currentProfile: ProfileKey = 'public';
  currentAccessTitle = 'Público';
  currentAccessSubtitle = 'Visor público';

  status = 'Activa capas RAM o conecta tu propio servicio GeoServer.';
  libraryReady = true;
  popupVisible = false;
  featureInfoPanelData?: FeatureInfoPanelData;
  publicInfoVisible = false;
  layersPanelVisible = false;
  aboutRamVisible = false;
  irrigatorParcelsPanelVisible = true;
  cadastralReferenceSearch = '';
  mobileMenuVisible = false;

  syncRoute(pathname: string): void {
    this.showCertificateCallback = pathname === '/auth/callback';
    this.showLogin = pathname === '/perfiles' || this.showCertificateCallback;
  }

  showIrrigatorLogin(): void {
    this.showIrrigatorAuth = true;
    this.showGuardAuth = false;
    this.showManagerAuth = false;
  }

  showGuardLogin(): void {
    this.showIrrigatorAuth = false;
    this.showGuardAuth = true;
    this.showManagerAuth = false;
  }

  showManagerLogin(): void {
    this.showIrrigatorAuth = false;
    this.showGuardAuth = false;
    this.showManagerAuth = true;
  }

  backToProfileSelection(): void {
    this.showIrrigatorAuth = false;
    this.showGuardAuth = false;
    this.showManagerAuth = false;
  }

  returnToIrrigatorAuth(): void {
    this.showCertificateCallback = false;
    this.showLogin = true;
    this.showIrrigatorAuth = true;
    this.showGuardAuth = false;
    this.showManagerAuth = false;
    this.certificateCallbackError = '';
  }

  startAuthenticatedSession(option: LoginOption): void {
    this.showIrrigatorAuth = false;
    this.showGuardAuth = false;
    this.showManagerAuth = false;
    this.currentAccessTitle = option.accessTitle;
    this.currentAccessSubtitle = option.accessSubtitle;
    this.currentProfile = option.key;
    this.closePublicPanels();
    this.showLogin = false;
  }

  restoreAuthenticatedProfile(option: LoginOption): void {
    this.currentAccessTitle = option.accessTitle;
    this.currentAccessSubtitle = option.accessSubtitle;
    this.currentProfile = option.key;
  }

  openProfileSelection(): void {
    this.mobileMenuVisible = false;
    this.showLogin = true;
    this.showCertificateCallback = false;
    this.showIrrigatorAuth = false;
    this.showGuardAuth = false;
    this.showManagerAuth = false;
    this.closePopup();
    this.closePublicPanels();
  }

  closeAuthenticatedSession(message: string): void {
    this.setPublicProfile();
    this.showLogin = false;
    this.showCertificateCallback = false;
    this.showIrrigatorAuth = false;
    this.showGuardAuth = false;
    this.showManagerAuth = false;
    this.closePopup();
    this.closePublicPanels();
    this.status = message;
  }

  setPublicProfile(): void {
    this.currentProfile = 'public';
    this.currentAccessTitle = 'Público';
    this.currentAccessSubtitle = 'Visor público';
  }

  isPublicAccess(): boolean {
    return this.currentProfile === 'public';
  }

  isIrrigatorAccess(): boolean {
    return this.currentProfile === 'irrigators';
  }

  isGuardAccess(): boolean {
    return this.currentProfile === 'guards';
  }

  isManagerAccess(): boolean {
    return this.currentProfile === 'managers';
  }

  togglePublicInformation(): void {
    if (!this.isPublicAccess()) {
      return;
    }

    this.publicInfoVisible = !this.publicInfoVisible;
    if (this.publicInfoVisible) {
      this.aboutRamVisible = false;
    }
  }

  toggleAboutRam(): void {
    if (!this.isPublicAccess()) {
      return;
    }

    const nextAboutRamVisible = !this.aboutRamVisible;
    this.aboutRamVisible = nextAboutRamVisible;
    if (nextAboutRamVisible) {
      this.publicInfoVisible = false;
    }
  }

  closeAboutRam(): void {
    this.aboutRamVisible = false;
  }

  closePublicPanels(): void {
    this.publicInfoVisible = false;
    this.layersPanelVisible = false;
    this.aboutRamVisible = false;
  }

  toggleIrrigatorParcelsPanel(): void {
    if (!this.isIrrigatorAccess()) {
      return;
    }

    this.irrigatorParcelsPanelVisible = !this.irrigatorParcelsPanelVisible;
  }

  showIrrigatorParcelsPanel(): void {
    if (!this.isIrrigatorAccess()) {
      return;
    }

    this.irrigatorParcelsPanelVisible = true;
  }

  hideIrrigatorParcelsPanel(): void {
    this.irrigatorParcelsPanelVisible = false;
  }

  openMobileMenu(): void {
    this.mobileMenuVisible = true;
  }

  closeMobileMenu(): void {
    this.mobileMenuVisible = false;
  }

  closePopup(): void {
    this.popupVisible = false;
    this.featureInfoPanelData = undefined;
  }

  showFeatureInfoPanel(data: FeatureInfoPanelData): void {
    this.featureInfoPanelData = data;
    this.popupVisible = true;
  }
}
